export enum DomainAggregateWorkspaceCapabilityAccessOperation {
    create = "8f417ba1-b44b-47b1-810a-8d04e4e48889",
    delete = "763c2601-38f5-46d3-87e6-175f7672ae76",
    read = "7f3e306e-0db4-4c79-92dc-59cf31557f5d",
    update = "0dbd67b8-3b2f-40b0-a76c-93cf51512560",
}
